export default __webpack_public_path__ + "static/img_3-19d5747f11777dc02c8d6e7b386daca1.png";